import * as React from 'react';
import { Spinner } from '@blueprintjs/core';

interface Props {
    imgURL
};

interface State {
    hasLoaded: boolean;
}

export class LoadableSVG extends React.Component<Props, State> {

    state: State = {
        hasLoaded: false
    }

	render() {
        const {
            imgURL
        } = this.props;

        const {
            hasLoaded
        } = this.state;

        const imageStyle = hasLoaded ? {maxHeight: '65vh', width: '100%', display: 'flex', margin: 'auto'} : {display: 'none'};

        return <span>
            {hasLoaded ? undefined : <Spinner />}
            <img
                style={imageStyle}
                src={imgURL}
                onLoad={() => {
                    this.setState({
                        hasLoaded: true
                    });
                }}
            />
        </span>
    }
}
